<script type="text/ecmascript-6">
    import DesignerQuestionSelectCompGlass from "../DesignerQuestionSelectCompGlass.vue";
    import SynsealTileQuestion from "../mixin/synseal/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionSelectCompGlass,
            SynsealTileQuestion
        ],
    }
</script>
